import Skeleton from "react-loading-skeleton";
import { useAssetsImage } from "~/pages/context/AssetsImageContext";

export default function ImageSkeleton({ id, heightLoading = 200, className = "", alt = "image", ...res }) {
    const { getImageUrlById, loading } = useAssetsImage();
    const src = getImageUrlById(id);

    if (loading) {
        return <Skeleton containerClassName="w-100" height={heightLoading} className={className} />;
    }

    if (!src) {
        return null;
    }

    return <img src={src} alt={alt} className={className} {...res}/>;
}
